<template>
	<!-- 配件购买 start-->
	<div class="grey-bg-sec" v-if="partList.length>0">
		<div class="accessories-sec">
			<div class="part-header">
				<span>配件购买【仅支持搭配特定商品购买】</span>
				<span class="icon-arrow-down" :class="{'icon-arrow-up':accesListShow==true}" @click="accesListShow=!accesListShow"></span>
			</div>
			<div class="part-list" v-show="accesListShow" >
				<div class="part-item" v-for="(item,index) in partList">
					<div class="part-img">
						<img :src="item.thumb" alt="">
					</div>
					<div class="part-operate">
						<div class="left">
							<p>{{item.goodsName}}</p>
							<p class="text-grey">¥{{item.salePrice | filterPrice}}</p>
						</div>
						<div class="right">
			            	<span class="part-btn" @click="showPartModal(item,index)">添加</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<mt-popup
		 	v-model="partSkuVisible"
		  	position="middle">
		  	<div class="partSku-content">
		  		<!-- <p class="partSku-title">请选择{{partList[partIndex].skuInfos[0] && partList[partIndex].skuInfos[0].skuProperty}}</p> -->
		  		<p class="partSku-title">请选择{{partList[partIndex].goodsName}}</p>
		  		<div class="partSkuList">
			  		<span 
			  		:class="skuList.some((skuId,index)=>skuId==item.skuId) ? 'skuItem active': 'skuItem'" 
			  		v-for="(item,index)  in partList[partIndex].skuInfos" 
			  		@click="skuItemChoose(item)"
			  		>
			  			<span class="subItem">{{item.skuPropertyValue}}</span>
			  		</span>
			  	</div>
			  	<div class="partSku-foot">
			  		<span class="cancel" @click="hideSkuModal">取消</span>
			  		<span class="submit" @click="addToPart">确定</span>
			  	</div>
		  	</div>

		</mt-popup>
	</div>
	<!-- 配件购买 end-->
</template>

<script>
	import Vue from 'vue';
	import { Toast,  Popup } from '@/js/mint-ui';
	import { mapState } from 'vuex';
	Vue.component(Popup.name, Popup);


	export default {
		data(){
			return {
				counter: 1,
				accesListShow: false,//显示配件
				partSkuVisible: false,//显示配件选择框 
				partIndex: 0,//当前显示配件index
				skuList: [],//已选择sku
			}
		},
		computed: mapState({
			partList: state => state.shopCart.partList
		}),
		methods: {
			
			skuItemChoose(item){
				let skuList = this.skuList;
				let checkedSkuId = [];
				if(skuList.some((sku,index)=>item.skuId == sku)){
					skuList.forEach((skuId,index) => {
						if(skuId !== item.skuId) {
							checkedSkuId.push(skuId)
						}
					});
					this.skuList = checkedSkuId;
				}else {
					this.skuList.push(item.skuId)
				}
			},
			hideSkuModal(){
				this.partSkuVisible = false;
				this.skuList = [];
			},
			addToPart(){
				let self = this;
				
				const skuList = this.skuList;
				if(skuList.length <= 0){
					Toast({
						message: '请选择',
						className: 'toastZindex',
						duration: 2000
					});
					return false;
				}

				const goodsChannelId=this.partList[this.partIndex].goodsChannelId;
				
				this.partSkuVisible = false;

				const params = skuList.map((item,index)=>{
					return  {
						skuId: item,
						goodsNum: 1,
						goodsChannelId: goodsChannelId
					}
				})

				this.skuList = [];
				console.log('addCart',params);
				this.$store.dispatch('addCart',params).then(function(res){
					self.$store.dispatch('getCartInfo');
				},function(err){
					console.log(err);
					Toast(err||'系统错误')
				})
			},
			showPartModal(item,index){
				this.partSkuVisible = true;
				this.partIndex = index;
			}
		},
		mounted(){
			
		}
	}


</script>


<style lang="scss">
@import '../../../assets/css/mixin';


.acces-border {
	border: 1px solid #BDBDBD;
}

.acces-table-footer {
	padding-right: pxToRem(40px);

	.acces-mark {
		border: none;
	}
}


.accessories-sec {
	padding: pxToRem(20px) 0;
	width: 100%;
	background-color: #fff;
	color: #666;
	.part-header {
		padding: pxToRem(20px) pxToRem(40px) pxToRem(20px) pxToRem(60px);
		display: flex;
		justify-content: space-between;
		font-size: pxToRem(20px);
	}

	.part-list {
		padding: 0 pxToRem(50px) pxToRem(60px) pxToRem(50px);
		font-size: 0;

		.part-item {
			margin-top: pxToRem(35px);
			display: inline-block;
			width: pxToRem(312px);
			height: pxToRem(340px);
			border: 1px solid #ccc;
			
			&:nth-of-type(2n+1){
				margin-right: pxToRem(26px);
			}
			.part-img {
				margin: pxToRem(38px) auto pxToRem(30px);
				width: pxToRem(172px);
				height: pxToRem(172px);
				text-align: center;
				img {
					width: 100%;
					max-width: 100%;
				}
			}
		}
		.part-operate {
			padding: 0 pxToRem(20px);
			display: flex;
			justify-content: space-between;
			font-size: pxToRem(20px);
			color: #191919;

			.left {
				width: 60%;
				&>p {
				    white-space: nowrap;
				    overflow: hidden;
				    text-overflow: ellipsis;
				}
			}

			.right {
				flex: 1;
			}

			.text-gray {
				font-size: pxToRem(18px);
			}

			.part-btn {
				display: inline-block;
				width: pxToRem(98px);
				height: pxToRem(42px);
				color: #D4B675;
				line-height: pxToRem(40px);
				text-align: center;
				font-size: pxToRem(20px);
				border: 1px solid #D4B675;

			}
		}
	}
	.up-count {
        position: absolute;
        top: 0;
        left: 25%;
        margin-left: pxToRem(10px);
        color: #D8331D;
        font-weight: bold;
        font-size: pxToRem(26px);
    }


    .fade-enter-active{
        top: - pxToRem(50px);
        transform: scale(1.2);
        opacity: 1;
        transition: all .5s ease;
    }
    .fade-enter/* .fade-leave-active in below version 2.1.8 */ {
        top: 0;
        transform: scale(1);
        opacity: 0;
    }
    .fade-leave-active {
        top: - pxToRem(20px);
        opacity: 0;
    }
  
    .fade-leave-to {
        top: - pxToRem(20px);
        opacity: 0;
    }

}
	


.partSku-content {
	.partSku-title {
		margin: pxToRem(70px) 0 pxToRem(40px) 0 ;
		text-align: center;
		color: #9B9B9B;
	}

	.partSkuList {
		display: flex;
    	flex-wrap: wrap;
		width: pxToRem(640px);
		padding: 0 pxToRem(50px) pxToRem(20px);
		.skuItem {
			padding: 0 pxToRem(10px) ;
			display: inline-flex;
			align-items: center;
    		justify-content: center;
			margin: 0 pxToRem(25px) pxToRem(30px) 0;
			width: pxToRem(115px);
			height: pxToRem(76px);
			border: 1px solid #979797;
			white-space: nowrap;
			overflow: hidden;

			.subItem {
				display: inline-block;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
			&:nth-child(4n){
				margin-right: 0
			}

			&.active {
				background: #3D2D23;
				color: #fff;
				border-color: #3D2D23;
			}
		}
	}

	.partSku-foot {
		display: flex;
		width: 100%;
		height: pxToRem(76px);
		justify-content: space-around;
		color: #fff;
		.cancel {
			display: inline-flex;
			flex: 1;
			justify-content: center;
			align-items: center;
			background: #CCCCCC;
		}
		.submit {
			display: inline-flex;
			flex: 1;
			justify-content: center;
			align-items: center;
			background: #D8331D;
		}
	}
	
}
.toastZindex {
	z-index: 99999999;
}
	
</style>


// WEBPACK FOOTER //
// productPart.vue?50b168ea